import { I18n } from '@calendly/i18n'
import { BodyText } from '@calendly/ui/components/typography'

import { NoUpcomingMeetingsCard } from './no_upcoming_meetings_card'
import { EmptyTodayWrapper, NoUpcomingMeetingWrapper } from './styles'

interface EmptyStateProps {
  type: 'NO_TODAY_MEETINGS' | 'NO_FUTURE_MEETINGS'
}

/**
 * Renders empty state cards for placeholder event types
 * Used when there are no meetings for a given time period
 */
export const EmptyState = ({ type }: EmptyStateProps) => {
  const EmptyTodayWrapperAny = EmptyTodayWrapper as any
  const NoUpcomingMeetingWrapperAny = NoUpcomingMeetingWrapper as any

  if (type === 'NO_TODAY_MEETINGS') {
    return (
      <EmptyTodayWrapperAny>
        <BodyText color="muted">
          {I18n.t('publisher.meetings.end_of_list.none_today')}
        </BodyText>
      </EmptyTodayWrapperAny>
    )
  }

  if (type === 'NO_FUTURE_MEETINGS') {
    return (
      <NoUpcomingMeetingWrapperAny>
        <NoUpcomingMeetingsCard />
      </NoUpcomingMeetingWrapperAny>
    )
  }

  return null
}
